var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5116 2.63444C12.1783 2.53201 11.822 2.53201 11.4887 2.63444L8.50297 3.55211C6.96862 4.02369 5.51144 4.71703 4.17766 5.61013C3.32982 6.17785 3.7317 7.50033 4.75205 7.50033H19.2482C20.2686 7.50033 20.6705 6.17784 19.8226 5.61013C18.4888 4.71703 17.0317 4.02369 15.4973 3.55211L12.5116 2.63444Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25012 21.0003C4.25012 20.5861 4.58591 20.2503 5.00012 20.2503H19.0001C19.4143 20.2503 19.7501 20.5861 19.7501 21.0003C19.7501 21.4145 19.4143 21.7503 19.0001 21.7503H5.00012C4.58591 21.7503 4.25012 21.4145 4.25012 21.0003Z",
    fill: "#303030"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25012 17.0003C6.25012 17.4145 6.58591 17.7503 7.00012 17.7503C7.41434 17.7503 7.75012 17.4145 7.75012 17.0003L7.75012 11.0003C7.75012 10.5861 7.41434 10.2503 7.00012 10.2503C6.58591 10.2503 6.25012 10.5861 6.25012 11.0003L6.25012 17.0003Z",
    fill: "#303030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 17.7503C11.5859 17.7503 11.2501 17.4145 11.2501 17.0003L11.2501 11.0003C11.2501 10.5861 11.5859 10.2503 12.0001 10.2503C12.4143 10.2503 12.7501 10.5861 12.7501 11.0003V17.0003C12.7501 17.4145 12.4143 17.7503 12.0001 17.7503Z",
    fill: "#303030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2501 17.0003C16.2501 17.4145 16.5859 17.7503 17.0001 17.7503C17.4143 17.7503 17.7501 17.4145 17.7501 17.0003V11.0003C17.7501 10.5861 17.4143 10.2503 17.0001 10.2503C16.5859 10.2503 16.2501 10.5861 16.2501 11.0003V17.0003Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBank);
export default __webpack_public_path__ + "static/media/ic_bank.c264368be7eabbb8d10721acdc80c266.svg";
export { ForwardRef as ReactComponent };